import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { isNumber } from 'lodash';
import { forwardRef, useMemo } from 'react';
import { styled } from 'styled-components';
import { flexbox, space, system } from 'styled-system';
import { Box } from '@design-system/box';
import { ignoredProps } from '@design-system/theme';
import { useGridContext } from '../contexts/GridContext';
import { getBpNum } from '../utils/getBpNum';
const getFlex = (width) => width ? `0 0 ${getWidth(width)}` : 1;
const getWidth = (width) => !isNumber(width) || width > 1 ? width : `${width * 100}%`;
export const Col = forwardRef((_a, ref) => {
    var _b;
    var { children, growLeft, growRight, offset, overrideRowGap, width } = _a, otherProps = __rest(_a, ["children", "growLeft", "growRight", "offset", "overrideRowGap", "width"]);
    const { colGap, columnsInMobile, gridWidth, numCols, rowGap } = useGridContext();
    const offsetMemoized = useMemo(() => (typeof offset === 'function' ? offset({ numCols }) : offset), [numCols, offset]);
    const widthMemoized = useMemo(() => (typeof width === 'function' ? width({ numCols }) : width), [numCols, width]);
    const clientWidth = typeof document === 'undefined' ||
        Number.isNaN((_b = document.documentElement) === null || _b === void 0 ? void 0 : _b.clientWidth)
        ? 0
        : document.documentElement.clientWidth;
    const sideSpace = gridWidth
        ? (clientWidth - gridWidth) / 2
        : getBpNum(colGap, '_');
    return (_jsx(ColStyled, Object.assign({ "$offset": offsetMemoized, tabIndex: -1, width: widthMemoized }, otherProps, { ref: ref, children: _jsx(ColInnerStyled, { display: "block", ml: growLeft
                ? {
                    _: growLeft === 'pageBorder'
                        ? -sideSpace
                        : getBpNum(colGap, '_') * -1,
                }
                : undefined, mr: growRight
                ? {
                    _: growRight === 'pageBorder'
                        ? -sideSpace
                        : getBpNum(colGap, '_') * -1,
                }
                : undefined, pl: {
                _: columnsInMobile ? getBpNum(colGap, '_') : 0,
                m: getBpNum(colGap, 'm'),
                l: getBpNum(colGap, 'l'),
                xl: getBpNum(colGap, 'xl'),
            }, pt: overrideRowGap !== null && overrideRowGap !== void 0 ? overrideRowGap : rowGap, children: children }) })));
});
const ColStyled = styled.div.withConfig({
    shouldForwardProp: (prop) => !ignoredProps.includes(prop),
}) `
  ${flexbox}
  ${space}
  ${system({
    $offset: {
        property: 'marginLeft',
        transform: getWidth,
    },
    width: {
        property: 'flex',
        transform: (width) => (width === 'content' ? undefined : getFlex(width)),
    },
})}

  ${system({
    width: {
        property: 'flexShrink',
        transform: (width) => (width === 'content' ? 0 : undefined),
    },
})}
  min-width: 0;
  max-width: 100%;
`;
const ColInnerStyled = styled(Box) `
  ${space}

  height: 100%;
`;
//# sourceMappingURL=Col.js.map